<template>
  <div>
    <div class="container">
      <Bread :list="breadList" class="ma-t-30" />
      <div class="flex f-wrap ma-t-30">
        <div v-for="(item, index) in dataList" :key="index" class="box-item ma-b-40" @click="$router.push({path:'/vod/detail',query:{id:item.ActivityId}})">
          <div class="item-img b-r-15 o-h">
            <img
              :src="item.Image"
              alt=""
              class="img_cover c-p"
              width="100%"
              height="234"
            />
            <div class="status">{{ item.TimeStatus }}</div>
          </div>
          <div class="font-bold pa-10 c-p t-omit-1">{{ item. Summary}}</div>
          <div class="flex f-between f-center pa-lr-10">
            <div class="fon-14 c-666 c-p t-omit-1">共{{item.MovieList.length}}部电影作品</div>
            <div class="btn-detail c-p">去观看</div>
          </div>
        </div>
      </div>

      <Empty :isShow="!dataList || dataList.length == 0"></Empty>
      <div class="fy t-center">
        <el-pagination
          @current-change="handleCurrentChange"
          :hide-on-single-page="true"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="totals"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getShowingList,
} from "../api.js";
export default {
  data() {
    return {
      breadList: [
        {
          name: "云展映",
          path: "/vod/index",
        },
      ],
      dataList: [],
      totals: 0, //一个分类下的总条数
      pageIndex: 1,
      pageSize: 16,
      categoryId: 0,
    };
  },
  activated() {
    this.loadDataList();
  },
  methods: {
    //获取列表数据
    loadDataList() {
      getShowingList({
          categoryId: this.categoryId,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          type:1
        }).then((res) => {
          this.dataList = res.data.Data.List;
          this.totals = res.data.Data.TotalCount;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 1150px;
}
.btn-detail {
  width: 92px;
  text-align: center;
  line-height: 30px;
  color: #fff;
  height: 30px;
  background: #f9014b;
  border-radius: 15px;
}

.box-item {
  width: 30%;
  .item-img {
    position: relative;
    .status {
      position: absolute;
      right: 0;
      top: 0;
      width: 80px;
      height: 35px;
      line-height: 30px;
      background: #0e932e;
      border-bottom-left-radius: 50px;
      color: #fff;
      text-align: center;
    }
  }
}
.box-item:not(:nth-child(3n)) {
  margin-right: calc(10% / 2);
}
</style>